import TreeSelect from './Select';
import TreeNode from '../TreeNode';
import './index.scss';

TreeSelect.TreeNode = TreeNode;
export default TreeSelect;
